/*
 * B2B Pre-selection (line-sheet) — client-side store.
 *
 * For B2B customers the Shopify cart is replaced by a browser-stored
 * "pre-selection". The "Add to Pre-selection" buttons carry a complete
 * product snapshot (rendered server-side in Liquid, so metafields + the B2B
 * catalog price are baked in — Shopify's product JSON omits metafields).
 *
 * Storage:
 *   akog:preselection      -> array of product snapshots (deduped by handle)
 *   akog:preselection:qty  -> { [variantId]: quantity }
 *
 * Snapshot shape:
 *   { handle, productId, title, url, image, color, material, rrp, productSku,
 *     sizes:[ { variantId, size, sku, wsp, available } ], addedAt, snapshotVersion }
 */
(function () {
  'use strict';
  if (window.__akogPreselectionInstalled) return;
  window.__akogPreselectionInstalled = true;

  var KEY = 'akog:preselection';
  var QKEY = 'akog:preselection:qty';
  var CHANGE = 'akog:preselection:change';

  /* ------------------------------------------------------------------ */
  /* Storage                                                            */
  /* ------------------------------------------------------------------ */
  function readList() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function writeList(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      console.warn('[preselection] could not save selection', e);
    }
    document.dispatchEvent(new CustomEvent(CHANGE));
  }
  function readQty() {
    try { return JSON.parse(localStorage.getItem(QKEY)) || {}; } catch (e) { return {}; }
  }
  function writeQty(map) {
    try { localStorage.setItem(QKEY, JSON.stringify(map)); } catch (e) {
      console.warn('[preselection] could not save quantities', e);
    }
  }

  function has(handle) {
    return readList().some(function (s) { return s.handle === handle; });
  }
  function upsert(snapshot) {
    var list = readList();
    var i = list.findIndex(function (s) { return s.handle === snapshot.handle; });
    if (i === -1) list.push(snapshot); else list[i] = snapshot;
    writeList(list);
  }
  function remove(handle) {
    var list = readList();
    var snap = list.filter(function (s) { return s.handle === handle; })[0];
    writeList(list.filter(function (s) { return s.handle !== handle; }));
    if (snap && snap.sizes) {
      var q = readQty();
      snap.sizes.forEach(function (sz) { delete q[sz.variantId]; });
      writeQty(q);
    }
  }

  /* ------------------------------------------------------------------ */
  /* Money formatting                                                   */
  /* ------------------------------------------------------------------ */
  function groupThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }
  function formatAmount(amount, decimals, thousandsSep, decimalSep) {
    if (isNaN(amount)) return '';
    var parts = Math.abs(amount).toFixed(decimals).split('.');
    var out = groupThousands(parts[0], thousandsSep);
    if (decimals && parts[1]) out += decimalSep + parts[1];
    return (amount < 0 ? '-' : '') + out;
  }
  // Renders a price from the store's money_format. Accepts cents (number),
  // a numeric/decimal string, a money object {amount,currency_code}, or an
  // already-formatted string (returned as-is).
  function formatMoney(value) {
    if (value === null || value === undefined || value === '') return '';
    var amount; // in major units
    if (typeof value === 'object') {
      if (value.amount == null) return '';
      amount = parseFloat(value.amount);
    } else if (typeof value === 'string') {
      if (/[^\d.,\s-]/.test(value)) return value; // already has a symbol/letters
      amount = parseFloat(value.replace(',', '.'));
    } else {
      amount = value / 100; // number = cents (variant.price)
    }
    if (isNaN(amount)) return '';

    var fmt = window.shopMoneyFormat || '€ {{amount}}';
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/g, formatAmount(amount, 2, ',', '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, formatAmount(amount, 0, ',', '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatAmount(amount, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, formatAmount(amount, 0, '.', ''))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, formatAmount(amount, 2, "'", '.'));
    // Decode the HTML entity some shops use for the euro/pound symbol, then
    // add a space after the symbol to match the theme's card styling ("€ 285").
    out = out.replace(/&euro;/g, '€').replace(/&pound;/g, '£').replace(/&yen;/g, '¥');
    out = out.replace(/([€$£¥])\s?(\d)/g, '$1 $2');
    return out.trim();
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ------------------------------------------------------------------ */
  /* Add / remove buttons + state sync                                  */
  /* ------------------------------------------------------------------ */
  function setButtonState(btn, added) {
    btn.setAttribute('data-preselection-state', added ? 'added' : 'add');
    var span = btn.querySelector('[data-preselection-label]');
    if (span) {
      span.textContent = added
        ? (btn.getAttribute('data-label-added') || 'Added ✓')
        : (btn.getAttribute('data-label-add') || 'Add to Pre-selection');
    }
    btn.classList.toggle('is-added', !!added);
  }
  function syncAllButtonStates() {
    var list = readList();
    var handles = {};
    list.forEach(function (s) { handles[s.handle] = true; });
    document.querySelectorAll('[data-preselection-add]').forEach(function (btn) {
      var handle = btn.getAttribute('data-preselection-handle');
      if (!handle) {
        try { handle = JSON.parse(btn.dataset.preselection).handle; } catch (e) { handle = null; }
      }
      setButtonState(btn, handle ? !!handles[handle] : false);
    });
  }

  document.addEventListener('click', function (evt) {
    var addBtn = evt.target.closest('[data-preselection-add]');
    if (addBtn) {
      // Cards are wrapped in an <a> — never navigate when toggling.
      evt.preventDefault();
      evt.stopPropagation();
      var snap;
      try { snap = JSON.parse(addBtn.dataset.preselection); } catch (e) { return; }
      if (!snap || !snap.handle) return;
      if (has(snap.handle)) { remove(snap.handle); setButtonState(addBtn, false); }
      else { upsert(snap); setButtonState(addBtn, true); }
      return;
    }
    var rmBtn = evt.target.closest('[data-preselection-remove]');
    if (rmBtn) {
      evt.preventDefault();
      evt.stopPropagation();
      remove(rmBtn.getAttribute('data-preselection-remove'));
    }
  });

  /* ------------------------------------------------------------------ */
  /* Header count badge                                                 */
  /* ------------------------------------------------------------------ */
  function updateHeaderCount() {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var count = readList().length;
    var bubble = link.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('span');
      bubble.className = 'cart-count-bubble';
      bubble.setAttribute('aria-hidden', 'true');
      link.appendChild(bubble);
    }
    bubble.textContent = count > 99 ? '99+' : String(count);
    bubble.style.display = count > 0 ? '' : 'none';
    link.classList.toggle('header__icon--cart-not-empty', count > 0);
    link.classList.toggle('is_empty', count === 0);
  }

  /* ------------------------------------------------------------------ */
  /* Pre-selection grid page                                            */
  /* ------------------------------------------------------------------ */
  function renderGrid(mount) {
    var list = readList();
    if (!list.length) {
      mount.innerHTML = '<li class="akog-preselection-empty">' +
        '<p>' + escapeHtml(mount.getAttribute('data-empty-text') || 'Your pre-selection is empty.') + '</p>' +
        '<a class="button" href="' + escapeHtml(mount.getAttribute('data-browse-url') || '/collections/all') + '">' +
        escapeHtml(mount.getAttribute('data-browse-text') || 'Browse products') + '</a></li>';
      return;
    }
    mount.innerHTML = list.map(function (s) {
      var img = s.image
        ? '<img src="' + escapeHtml(s.image) + '" alt="' + escapeHtml(s.title) + '" loading="lazy" class="motion-reduce">'
        : '';
      return '' +
      '<li class="grid__item">' +
        '<div class="card-wrapper product-card-wrapper">' +
          '<div class="card card--standard card--media">' +
            '<div class="card__inner ratio" style="--ratio-percent:125%;">' +
              '<div class="card__media"><div class="media media--transparent media--hover-effect">' +
                '<a href="' + escapeHtml(s.url) + '" class="full-unstyled-link" tabindex="-1">' + img + '</a>' +
              '</div></div>' +
            '</div>' +
            '<div class="card__content"><div class="card__information">' +
              '<h3 class="card__heading"><a href="' + escapeHtml(s.url) + '" class="full-unstyled-link">' + escapeHtml(s.title) + '</a></h3>' +
              (s.color ? '<div class="card-information akog-preselection-card__meta">' + escapeHtml(s.color) + '</div>' : '') +
              '<a href="#" class="akog-preselection-card__remove link" data-preselection-remove="' + escapeHtml(s.handle) + '">Remove</a>' +
            '</div></div>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('');
  }

  /* ------------------------------------------------------------------ */
  /* Final selection line-sheet                                         */
  /* ------------------------------------------------------------------ */
  function rowQtyTotal(snap, qty) {
    var units = 0, value = 0;
    snap.sizes.forEach(function (sz) {
      var n = parseInt(qty[sz.variantId], 10) || 0;
      units += n;
      value += n * (parseInt(sz.wsp, 10) || 0);
    });
    return { units: units, value: value };
  }

  function renderFinal(mount) {
    var list = readList();
    if (!list.length) {
      mount.innerHTML = '<p class="akog-final-empty">' +
        escapeHtml(mount.getAttribute('data-empty-text') || 'Your pre-selection is empty.') + ' ' +
        '<a href="' + escapeHtml(mount.getAttribute('data-browse-url') || '/collections/all') + '">Browse products</a></p>';
      return;
    }
    var qty = readQty();

    var rows = list.map(function (s) {
      var sizeCells = s.sizes.map(function (sz) {
        var val = parseInt(qty[sz.variantId], 10) || 0;
        return '<div class="akog-final__size">' +
          '<span class="akog-final__size-label">' + escapeHtml(sz.size) + '</span>' +
          '<input type="number" min="0" inputmode="numeric" class="akog-final__qty-input" ' +
            'value="' + (val || 0) + '" ' +
            'data-variant-id="' + escapeHtml(sz.variantId) + '" ' +
            'data-wsp="' + (parseInt(sz.wsp, 10) || 0) + '" ' +
            'data-row="' + escapeHtml(s.handle) + '" ' +
            'aria-label="' + escapeHtml(s.title + ' ' + sz.size) + '">' +
          '</div>';
      }).join('');

      var t = rowQtyTotal(s, qty);
      var firstWsp = s.sizes.length ? s.sizes[0].wsp : 0;

      return '' +
      '<tr data-row="' + escapeHtml(s.handle) + '">' +
        '<td class="akog-final__article">' +
          (s.image ? '<a href="' + escapeHtml(s.url) + '"><img src="' + escapeHtml(s.image) + '" alt="" loading="lazy"></a>' : '') +
          '<div class="akog-final__article-info">' +
            '<a href="' + escapeHtml(s.url) + '" class="akog-final__title">' + escapeHtml(s.title) + '</a>' +
            (s.color ? '<div class="akog-final__meta">COLOR: ' + escapeHtml(s.color) + '</div>' : '') +
            (s.material ? '<div class="akog-final__meta">MATERIAL: ' + escapeHtml(s.material) + '</div>' : '') +
            '<a href="#" class="akog-final__remove link" data-preselection-remove="' + escapeHtml(s.handle) + '">Remove</a>' +
          '</div>' +
        '</td>' +
        '<td class="akog-final__pid">' + escapeHtml(s.productSku || '') + '</td>' +
        '<td class="akog-final__wsp">' + escapeHtml(formatMoney(firstWsp)) + '</td>' +
        '<td class="akog-final__rrp">' + escapeHtml(formatMoney(s.rrp)) + '</td>' +
        '<td class="akog-final__sizerun">' + sizeCells + '</td>' +
        '<td class="akog-final__rowqty" data-rowqty="' + escapeHtml(s.handle) + '">' + t.units + '</td>' +
        '<td class="akog-final__rowtotal" data-rowtotal="' + escapeHtml(s.handle) + '">' + escapeHtml(formatMoney(t.value)) + '</td>' +
      '</tr>';
    }).join('');

    mount.innerHTML = '' +
      '<table class="akog-final-table">' +
        '<thead><tr>' +
          '<th>ARTICLE</th><th>PRODUCT ID</th><th>WSP</th><th>RRP</th>' +
          '<th>SIZE RUN</th><th>QTY</th><th>TOTAL</th>' +
        '</tr></thead>' +
        '<tbody>' + rows + '</tbody>' +
        '<tfoot><tr>' +
          '<td colspan="5" class="akog-final__grand-label">TOTAL</td>' +
          '<td class="akog-final__grand-qty" data-grandqty>0</td>' +
          '<td class="akog-final__grand-total" data-grandtotal></td>' +
        '</tr></tfoot>' +
      '</table>';

    recomputeAll(mount);
  }

  function recomputeRow(mount, handle) {
    var snap = readList().filter(function (s) { return s.handle === handle; })[0];
    if (!snap) return;
    var qty = readQty();
    var t = rowQtyTotal(snap, qty);
    var qcell = mount.querySelector('[data-rowqty="' + cssEscape(handle) + '"]');
    var tcell = mount.querySelector('[data-rowtotal="' + cssEscape(handle) + '"]');
    if (qcell) qcell.textContent = t.units;
    if (tcell) tcell.textContent = formatMoney(t.value);
  }
  function recomputeAll(mount) {
    var list = readList();
    var qty = readQty();
    var grandUnits = 0, grandValue = 0;
    list.forEach(function (s) {
      var t = rowQtyTotal(s, qty);
      grandUnits += t.units;
      grandValue += t.value;
      var qcell = mount.querySelector('[data-rowqty="' + cssEscape(s.handle) + '"]');
      var tcell = mount.querySelector('[data-rowtotal="' + cssEscape(s.handle) + '"]');
      if (qcell) qcell.textContent = t.units;
      if (tcell) tcell.textContent = formatMoney(t.value);
    });
    var gq = mount.querySelector('[data-grandqty]');
    var gt = mount.querySelector('[data-grandtotal]');
    if (gq) gq.textContent = grandUnits;
    if (gt) gt.textContent = formatMoney(grandValue);
  }

  function cssEscape(str) {
    return String(str).replace(/["\\]/g, '\\$&');
  }

  // Live quantity edits on the final table.
  document.addEventListener('input', function (evt) {
    var input = evt.target.closest('.akog-final__qty-input');
    if (!input) return;
    var mount = document.getElementById('akog-final-selection');
    if (!mount) return;
    var vid = input.getAttribute('data-variant-id');
    var handle = input.getAttribute('data-row');
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    var q = readQty();
    if (n === 0) delete q[vid]; else q[vid] = n;
    writeQty(q);
    recomputeRow(mount, handle);
    recomputeAll(mount);
  });

  /* ------------------------------------------------------------------ */
  /* Boot + reactivity                                                  */
  /* ------------------------------------------------------------------ */
  function boot() {
    updateHeaderCount();
    syncAllButtonStates();
    var grid = document.getElementById('akog-preselection-grid');
    if (grid) renderGrid(grid);
    var final = document.getElementById('akog-final-selection');
    if (final) renderFinal(final);
  }

  document.addEventListener(CHANGE, function () {
    updateHeaderCount();
    syncAllButtonStates();
    var grid = document.getElementById('akog-preselection-grid');
    if (grid) renderGrid(grid);
    var final = document.getElementById('akog-final-selection');
    if (final) renderFinal(final);
  });
  // Cross-tab sync.
  window.addEventListener('storage', function (e) {
    if (e.key === KEY || e.key === QKEY) boot();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Tiny public surface (handy for debugging / future cart wiring).
  window.AkogPreselection = {
    list: readList, quantities: readQty, has: has,
    add: upsert, remove: remove, formatMoney: formatMoney,
  };
})();
